import * as yup from 'yup';
import { MODULES_IDS } from '../../components/Constants';

export const ComunicadoColumnList = (isAdmin) => {
   return [
      {
         id: 'comunicado_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'comunicado_conjunto_id',
         dbname: 'conjunto_id',
         label: 'conjunto_id',
         visible: !!isAdmin,
         form: !!isAdmin,
         filter: !!isAdmin,
         foreign: {
            table: 'conjunto',
            label: 'conjunto',
            dbname: 'conjuntodesc',
            type: 'large'
         }
      },
      {
         id: 'comunicado_titulo',
         dbname: 'titulo',
         label: 'titulo',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'comunicado_texto',
         dbname: 'texto',
         label: 'texto',
         visible: false,
         form: true,
         filter: false,
         type: 'text',
         htmlEditor: true
      },
      {
         id: 'comunicado_fecha_vencimiento',
         dbname: 'fecha_vencimiento',
         label: 'fecha_vencimiento',
         visible: true,
         form: true,
         filter: true,
         type: 'date',
      },
      {
         id: 'comunicado_tipo_estado_id',
         dbname: 'tipo_estado_id',
         label: 'tipo_estado_id',
         visible: true,
         form: true,
         filter: true,
         foreign: {
            table: 'tipo_estado',
            label: 'tipo_estado',
            dbname: 'tipo_estadodesc',
            type: 'small',
            filters: { modulo_id: MODULES_IDS.COMUNICADOS }
         }
      },
   ];
};

export const ComunicadoValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().nullable(),
      titulo: yup.string().nullable(),
      texto: yup.string().nullable(),
      fecha_vencimiento: yup.date().nullable(),
      tipo_estado_id: yup.number().nullable(),
   });
};

export const ComunicadoFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().nullable(),
      titulo: yup.string().nullable(),
      texto: yup.string().nullable(),
      fecha_vencimiento: yup.date().nullable(),
      tipo_estado_id: yup.number().nullable(),
   });
};